import { getRouterNavigator } from '@/routing'

export function handleForcefulClose() {
  const navigate = getRouterNavigator()
  navigate('/error/logged-out')
}
